export const LOGIN              = 'LOGIN';
export const LOGOUT             = 'LOGOUT';
export const UPDATE_USER        = 'UPDATE_USER';
export const SET_PROVIDER       = 'SET_PROVIDER';
export const GET_CATEGORIES     = 'GET_CATEGORIES';
export const LOADING            = 'LOADING';
export const IDLE               = 'IDLE';

export const UPDATE_INBOX_STATISTICS    = 'UPDATE_INBOX_STATISTICS';
export const LOADING_INBOX_STATS        = 'LOADING_INBOX_STATS';
export const IDLE_INBOX_STATS           = 'IDLE_INBOX_STATS';


// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js